module.exports = __webpack_public_path__ + "img/dp3.694126e9.jpeg";